/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopMonthlyReport from './_PopMonthlyReport';
function MonthlyReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '과탐', value: 3},
    {title: '사탐', value: 4},
    {title: '논술', value: 5},
    {title: '면접', value: 6},
    {title: '생디', value: 7},
    {title: '미작성', type: ' red', value: 8},
    {title: '내 보고서', value: 9}
  ];
  const [modalMonthlyReport, setModalMonthlyReport] = useState(false);
  return (
    <main className="com_container p_monthly_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_17">4주 8주 보고서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalMonthlyReport(true)} className="com_btn orange s btn_plus">
              4주 8주 보고서 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select no_tab">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">4주</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">8주</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="10%" />
                <col width="13%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="9%" />
                <col width="10%" />
                <col width="10%" />
                <col width="11%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>최근 수업일</th>
                  <th>수업 회차</th>
                  <th>교사명</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>담임명</th>
                  <th>비고</th>
                  <th>담임 보고서</th>
                  <th>학부모 설문조사</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>11</td>
                  <td className="td_date td_red">미등록</td>
                  <td className="td_date">2022.08.25</td>
                  <td>1T 3/16</td>
                  <td>
                    <button className="btn_link">가교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">가학생102</button>
                  </td>
                  <td>수학</td>
                  <td>
                    <button className="btn_link">가담임102</button>
                  </td>
                  <td>
                    <button className="btn_link red">미등록</button>
                  </td>
                  <td>
                    <button className="btn_link red">미등록</button>
                  </td>
                  <td></td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25</td>
                      <td className="td_date">2022.08.25 06:30</td>
                      <td>1T 3/16</td>
                      <td>
                        <button className="btn_link">가교사102</button>
                      </td>
                      <td>
                        <button className="btn_link">가학생102</button>
                      </td>
                      <td>수학</td>
                      <td>
                        <button className="btn_link">가담임102</button>
                      </td>
                      <td>
                        <button className="btn_link blue">2023, 05, 10</button>
                      </td>
                      <td>
                        <button className="btn_link blue">2023, 05, 10</button>
                      </td>
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">김교사104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit" />
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 회차</span>
                  <span className="cont">4/25</span>
                </div>
                <div className="info">
                  <span className="tit">최근 진행 수업일시</span>
                  <span className="cont">2023.05.10 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <button className="btn_link">김교사302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className="btn_link">김담임302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
              </div>
              <div className="board_item">
                <div className="cont">
                  <ul className="list">
                    <li className="item">
                      1. 이번달 진도에대해 평가해 주세요 : <span className="bold">중</span>
                    </li>
                    <li className="item">
                      2. 학생의 수업태도는 평가해 주세요 : <span className="bold">중</span>
                    </li>
                    <li className="item">
                      3. 점검회사별 과제이행정도를 평가해 주세요 : <span className="bold">중</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="board_item">
                <div className="cont">
                  <p className="cont bold">학부모 설문조사</p>
                  <ul className="list">
                    <li className="item">
                      1. 이번달 진도에대해 평가해 주세요 : <span className="bold">중</span>
                    </li>
                    <li className="item">
                      2. 학생의 수업태도는 평가해 주세요 : <span className="bold">중</span>
                    </li>
                    <li className="item">
                      3. 점검회사별 과제이행정도를 평가해 주세요 : <span className="bold">중</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopMonthlyReport open={modalMonthlyReport} close={() => setModalMonthlyReport(false)} />
    </main>
  );
}

export default MonthlyReport;
